import { gql } from '@apollo/client';

export const SuppliersPageUpdateDeliverySettingMutation = gql`
  mutation SuppliersPageUpdateDeliverySetting(
    $input: SupplierDeliverySettingInput!
  ) {
    updateSupplierDeliverySetting(input: $input) {
      id
      __typename
    }
  }
`;
